import { Textarea } from '../../../../../common/forms/Textarea';

export const ReplaceJobAssignmentBody = () => (
    <Textarea
        id="replacementReason"
        name="replacementReason"
        label="Reason for Replacement"
        placeholder="Please explain why you are replacing this assignment"
        rows={4}
        required
        error="A replacement reason must be provided."
    />
);
